import React from "react";
import { useLocation } from "react-router-dom";
import { Helmet } from "react-helmet-async";
import routeMeta from "./routeMeta.json";

const ORIGIN = "https://quarec.com";
const DEFAULT = routeMeta["/"];

// One canonical URL and basic social metadata per public client route.
// Dynamic backend articles also receive route-specific URL metadata while their
// title/content are loaded by FullBlog. True server rendering of dynamic articles
// still requires backend integration.
export default function RouteSeo() {
  const { pathname } = useLocation();
  const path = pathname === "/" ? "/" : pathname.replace(/\/+$/, "");
  const matched = routeMeta[path];
  const isDynamicBlog = /^\/(blog|FullBlog)\/[^/]+$/i.test(path);
  const isDynamicService = /^\/service-details\/[^/]+$/i.test(path);
  const data = matched || (isDynamicBlog ? {title: "Quarec Resources | HR Insights", description: "Read hiring and career insights from Quarec Resources."} : DEFAULT);
  const canonical = `${ORIGIN}${path}`;
  const indexable = Boolean(matched || isDynamicBlog || isDynamicService);

  return (
    <Helmet>
      <html lang="en" />
      <title>{data.title}</title>
      <meta name="description" content={data.description} />
      <link rel="canonical" href={canonical} />
      <meta name="robots" content={indexable ? "index,follow" : "noindex,follow"} />
      <meta property="og:type" content={isDynamicBlog ? "article" : "website"} />
      <meta property="og:site_name" content="Quarec Resources" />
      <meta property="og:title" content={data.title} />
      <meta property="og:description" content={data.description} />
      <meta property="og:url" content={canonical} />
      <meta name="twitter:card" content="summary" />
    </Helmet>
  );
}
